// src/utils/socket.js
import { io } from 'socket.io-client';
import router from '@/router/index.js' // 如果你有路由文件，取消注释用于跳转登录页

class SocketService {
  /** 分发类型 一对一 one-on-one 一对多 one-to-many */
  distribute_str = ['one-on-one', 'one-to-many'];
  /** 消息类型 系统消息 SystemMessage 用户消息 UserMessage */
  type_str = ["SystemMessage", "UserMessage"];

  constructor() {
    this.socket = null;
    // 注意：这里改成你后端的真实地址，比如 http://127.0.0.1:5000
    this.url = 'https://www.aboluo.site';
    this.isConnected = false;
    // 新增：用于存储当前的 SID
    this.currentSocketId = null;
  }

  // 1. 初始化连接
  connect() {
    if (this.socket && this.socket.connected) {
      return; // 如果已经连上了，就不要重复连
    }

    // 建立连接
    this.socket = io(this.url, {
      transports: ['websocket'], // 强制使用 websocket
      reconnection: true,        // 开启自动重连
      reconnectionAttempts: 10,  // 重试10次
      reconnectionDelay: 1000    // 每次间隔1秒
    });

    // 监听连接成功
    this.socket.on('connect', () => {
      this.isConnected = true;
      this.currentSocketId = this.socket.id;
      // console.log('📡 新的 Socket ID:', this.currentSocketId);

      // ✅ 【关键修复】每次 connect（包括重连）都更新 LocalStorage
      if (this.currentSocketId) {
        localStorage.setItem('socket_sid', this.currentSocketId);
      }

      // ✅ 【关键】如果是重连，我们需要通知后端：“我换新ID了，请更新你的记录”
      // 这里需要结合你的登录状态。如果用户已登录，发送 Token 告知后端更新
      const token = localStorage.getItem('token'); // 假设你的 Token 存在这里
      if (token) {
        // 发送一个自定义事件，告诉后端刷新 Socket ID
        // 注意：后端 /api/VerifyTK 或专门的 /socket/refresh 接口需要支持这个逻辑
        this.socket.emit('client_reconnect', { token, new_sid: this.currentSocketId });
      }
    });

    // 监听连接断开
    this.socket.on('disconnect', () => {
      // console.log('❌ WebSocket 断开连接');
      this.isConnected = false;
      this.currentSocketId = null;
      // 断开时清除 localStorage 中的 ID (可选)
      localStorage.removeItem('socket_sid');
    });
  }

  // 2. 加入房间
  joinRoom(roomId) {
    if (this.isConnected) {
      // console.log(`👉 加入房间: ${roomId}`);
      this.socket.emit('join_room', roomId);
    }
  }

  // 3. 监听消息
  on(eventName, callback) {
    if (this.socket) {
      this.socket.on(eventName, callback);
    }
  }

  // 4. 发送消息
  emit(eventName, data, callback) {
  if (this.isConnected) {
    this.socket.emit(eventName, data, callback);  // 把 callback 传进去
  }
}

  /**
   * 通过接收到后端消息体后验证当前在线客户端是否接收消息
   * 目前可实现用户对用户或系统对用户或系统对同盟成员或用户对同盟的消息体互通
   * @todo 待实现指定群体一对多的消息体互通功能
   * @param {Object} data 后端返回的消息数据
   * @param {*} verifyDataTo 验证数据来源,默认为浏览器本地缓存,非浏览器本地缓存时传入一个Object
   * @returns 返回一个消息体Object数据,其中包含是否接收success,本条消息体的类型types,消息体内容message,其他消息op
   */
  diversion(data, verifyDataTo = 'localStorage') {
    let currentRouteName = router.currentRoute.value ? router.currentRoute.value.name : router.currentRoute.name;
    var veriftyData = {};
    var message, types, op = "";
    var success = false;
    if (verifyDataTo == 'localStorage') {
      if (currentRouteName === 'ShuaituMorPPage') {
        veriftyData = JSON.parse(localStorage.getItem("userData")).user.user;
      } else if (currentRouteName === 'DashboardPage') {
        veriftyData = JSON.parse(localStorage.getItem('background_user_info'));
      } else {
        console.error('传入值错误！');
        success = false;
        message = '传入值错误！';
        success = data.op;
        return {
          success: success,
          message: message,
          types: types,
          op: op
        }
      }
    } else {
      veriftyData = verifyDataTo;
    }

    if (!this.distribute_str.includes(data.distribute)) {
      this.$messageX.xiaoxiti("e", `系统运行出现错误！【非法distribute值】【${data.distribute}】`);
    }
    if (!this.type_str.includes(data.types)) {
      this.$messageX.xiaoxiti("e", `系统运行出现错误！【非法types值】【${data.types}】`);
    }

    if (data.distribute == 'one-on-one') {
      if (data.exclude.replace(/\s+/g, '') != '' && data.excludeField.replace(/\s+/g, '') != '') {
        if (veriftyData[data.excludeField] == data.exclude) {
          success = false;
          types = data.types;
          message = data.message;
          op = data.op;
          return {
            success: success,
            message: message,
            types: types,
            op: op
          }
        }
      }
      if (veriftyData[data.validationField] == data.fieldData) {
        success = true;
        types = data.types;
        message = data.message;
        op = data.op;
      }
    } else if (data.distribute == 'one-to-many') {
      console.log("1-X");
    }
    return {
      success: success,
      message: message,
      types: types,
      op: op
    }
  }
}

// 导出单例（保证全项目只有一个连接）
const socketService = new SocketService();
export default socketService;